import styled from 'styled-components';
import { theme } from '@/components/features/theme/theme';

export const StyledBlogDetails = styled.section`
    padding: 120px 0 120px;
    position: relative;

    &:after {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 300px;
        background: linear-gradient(180deg, #FFFDFA 0%, #EEE4D9 100%);
        content: '';
        z-index: -1;
        display: none;
    }

    .blog_details__left {
        .back {
            margin-bottom: 20px;
            svg {
                width: 8px;
                height: 8px;
                flex-shrink: 0;
            }
            a {
                color: #BB9753;
                font-size: 0.7rem;
                font-style: normal;
                font-weight: 600;
                line-height: 1rem;
                letter-spacing: -0.021rem;
                span {
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                }
            }
        }
        .heading {
            h1 {
                color: #303030;
                font-size: 2.4rem;
                font-style: normal;
                font-weight: 500;
                line-height: 2.616rem;
                letter-spacing: -0.072rem;
                font-family: ${theme.fonts.body};
                margin-bottom: 20px;
            }
            ul {
                display: flex;
                li {
                    position: relative;
                    font-size: 0.7rem;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 1rem;
                    color: #534D40;
                    span {
                        margin: 0 3px;
                    }
                }
            }
            margin-bottom: 30px;
        }
    }
    .blog_details__right {
        .banner_image_wrapper {
            margin-bottom: 45px;
            padding-top: calc(380 / 750 * 100%);
            position: relative;
        }
        p {
            color: #394149;
            font-size: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 1.53rem;
            letter-spacing: -0.023rem;
        }
    }

    @media (max-width: 767px) {
        padding-top: 80px;
        .social-list-wrap-div {
            margin-bottom: 30px;
        }
        .image-flex {
            margin-bottom: 40px;
        }
    }
`;